<template>
  <div>
    <div
      v-show="inMeeting"
      class="top-bar">
      <nav-bar-jitsi
        ref="navBar"
        :meeting-name="meetingName"
        :meeting-info="meetingInfo"
        :is-moderator="myUser.role === 'moderator'"
        fixed="top"/>
    </div>
    <div
      class="jitsi"
      :class="{ meeting: inMeeting }">
      <b-container
        ref="containerMeeting"
        fluid>
        <div
          ref="meet"
          class="overflow-hidden videoArea"
        />
      </b-container>
    </div>
    <div>
      <make-moderator/>
    </div>
  </div>
</template>

<script>
import {ref, onMounted} from "@vue/composition-api"
import {parseJwt} from "../functions/globalMethods"
import {getJitsiToken, saveJitsiToken, loadStorageData, saveCorenexaToken, getCorenexaToken} from "../functions/storageManager"
import { parseMyself } from "../functions/utils"
import { gaEvent } from "../functions/gtag"
import NavBarJitsi from "./NavBarJitsi"
import MakeModerator from './MakeModerator'

export default {
  name: 'JoinMeeting',
  components: {
    'make-moderator': MakeModerator,
    'nav-bar-jitsi': NavBarJitsi,
  },
  setup(props, context) {
    const expanded = ref(false)
    const inMeeting = ref(false)
    const domain = ref("150-136-245-73-meta.corenexa.com:9443") //Here goes your domain where the meeting takes place.
    const meet = ref(null)
    const options = ref({})
    const meta_token = ref('')
    const corenexa_token = ref('')
    const roomName = ref('')
    const meetingName = ref("")
    const meetingInfo = ref({})
    const cnv_api = ref('https://api.corenexa.com')
    document.body.style.backgroundColor = "#141414"
    const javaCall = ref(false)
    const javaMinimized = ref(false)
    const directly = ref(false)
    const rejoinHref = ref(window.location.href)
    const myUser = ref({})
    const localParticipantId = ref('') // my Jitsi participant id, set on join
    const unload = ref(false) // set to true on reload
    const lastChatState = ref(false);

    loadStorageData()
    window.javaSetMinimizeMode = setMinimizeMode

    // function mapped to window so can be called from Java code
    window.javaLeave = javaLeave

    let storedJitsiToken = getJitsiToken()
    let href = window.location.href
    if (context.root.$route.query.r) {
      meta_token.value = context.root.$route.query.r
      window.location.href = href.replace(`r=${meta_token.value}`, "")
      href = window.location.href
    } else if (context.root.$route.query.u) {
      meta_token.value = context.root.$route.query.u
      window.location.href = href.replace(`u=${meta_token.value}`, "")
      href = window.location.href
    } else if (storedJitsiToken) {
      meta_token.value = storedJitsiToken
    }
    if(meta_token.value) {
      saveJitsiToken(meta_token.value)
    }
    if (jitsiTokenExpired()) {
      window.location.href ='/#/'
      window.location.reload()
    }
    if (!!context.root.$route.query.directly) {
      directly.value = Boolean(context.root.$route.query.directly);
    }
    if (context.root.$route.query.meetingID) {
      roomName.value = context.root.$route.query.meetingID
      window.location.href = href.replace(`meetingID=${roomName.value}`, "")
      href = window.location.href
    }
    let storedCorenexaToken = getCorenexaToken()
    if (context.root.$route.query.c) {
      corenexa_token.value = context.root.$route.query.c
      window.location.href = href.replace(`c=${corenexa_token.value}`, "")
      href = window.location.href
    } else if (storedCorenexaToken) {
      corenexa_token.value = storedCorenexaToken
    }
    if(corenexa_token.value) {
      saveCorenexaToken(corenexa_token.value)
    }
    if (context.root.$route.query.domain) {
      domain.value = context.root.$route.query.domain
    }
    if (context.root.$route.query.api) {
      cnv_api.value = context.root.$route.query.api
    }

    function handleUnload() {
      window.removeEventListener('beforeunload', handleUnload);
      unload.value = true;
      // best-effort stop so a recording isn't orphaned when the window is closed
      if (context.root.api && context.refs.navBar && context.refs.navBar.recording) {
        context.root.api.executeCommand('stopRecording', 'file')
      }
    }

    window.addEventListener('beforeunload', handleUnload);

    onMounted(async () => {
      loadJsFile('https://' + domain.value + '/external_api.js')
    })

    function loadJsFile(filePath) {
      // Create a <script> tag, set its source
      let scriptTag = document.createElement('script')

      // And listen to it
      scriptTag.onload = function (loadEvent) {
        // This function is an event handler of the script tag
          joinJitsi()
      }

      // Make sure this file actually loads instead of a cached version
      // Add a timestamp onto the URL (i.e. file.js?bust=12345678)
      let cacheBuster = '?bust=' + new Date().getTime()

      // Set the type of file and where it can be found
      scriptTag.type = 'text/javascript'
      scriptTag.src = filePath + cacheBuster

      // Finally add it to the <head>
      document.getElementsByTagName('head')[0].appendChild(scriptTag)
    }

    function joinJitsi() {
      options.value = {
        roomName: roomName.value, //This is the name of the room. Quite obvious.
        width: "100%",
        height: "100%",
        parentNode: meet.value, //Now, you declare here which element should parent your stream.
        configOverwrite: {
          toolbarButtons: [
            'camera',
            'chat',
            'closedcaptions',
            'desktop',
            //'download',
            //'embedmeeting',
            //'etherpad',
            //'feedback',
            'filmstrip',
            'fullscreen',
            'hangup',
            //'help',
            'highlight',
            //'invite',
            //'linktosalesforce',
            //'livestreaming',
            'microphone',
            'noisesuppression',
            'participants-pane',
            'profile',
            'raisehand',
            //'recording', // replaced by our own moderator-only Start/Stop control
            //'security',
            'select-background',
            'settings',
            //'shareaudio',
            'sharedvideo',
            'shortcuts',
            'stats',
            'tileview',
            'toggle-camera',
            'videoquality',
            'whiteboard',
],
          //toolbarConfig: {initialTimeout: 1, timeout: 1},
          prejoinConfig: {enabled: true & !directly.value, hideDisplayName: true},
          hiddenPremeetingButtons: ['invite'],
          prejoinPageEnabled: false,
          disableSelfViewSettings: true,
          useHostPageLocalStorage: true,
          hideConferenceSubject: true,
          hideConferenceTimer: true,
          hideDominantSpeakerBadge: true,
          disableDeepLinking: true,
          fileRecordingsEnabled: true,
          // intercept hangup so we can stop an active recording before leaving
          buttonsWithNotifyClick: ['hangup'],
          recordingService: {
            enabled: true,
            sharingEnabled: false,
            hideStorageWarning: true},
          dropbox: {
            appKey: null
          },
          localRecording: {
            disable: false,
            notifyAllParticipants: true,
            disableSelfRecording: true
          },
          lobby: {
            autoKnock: true,
            enableChat: false
          },
          videoQuality: {
            maxBitratesVideo: {
              VP8: {low: 100000, standard: 400000, high: 1000000}
            }
          },
          recordings: {
            suggestRecording: false,
            showRecordingLink: false // we present our own download popup instead
          }
        },
        jwt: meta_token.value,
			}

      context.root.api = new JitsiMeetExternalAPI(domain.value, options.value) //This is where the iframe is actually constructed
      context.root.api.addEventListener(`videoConferenceJoined`, (value) => {
        meetingName.value = context.root.$route.query.meetingName ? context.root.$route.query.meetingName : roomName.value
        localParticipantId.value = value.id
        inMeeting.value = true
        if (window.java) {
          javaCall.value = true
        }
      })
  
      context.root.api.addEventListener('readyToClose', () => {
        if (!unload.value) {
          // do not call exitMeeting on page reload
          exitMeeting(true);
        }
      })
  
      context.root.api.addEventListener('participantJoined', (participant) => {
        context.refs.navBar.setParticipantVolume(participant.id)
      })

      context.root.api.addEventListener('recordingStatusChanged', (e) => {
        if (context.refs.navBar) {
          context.refs.navBar.setRecordingStatus(e.on)
        }
        if (e.error) {
          console.warn('recording error:', e.error)
          context.root.$notify.error('Recording error: ' + e.error)
        }
      })

      // JaaS/Jitsi delivers the finished recording URL here; show our own download popup
      context.root.api.addEventListener('recordingLinkAvailable', (e) => {
        if (context.refs.navBar) {
          context.refs.navBar.setRecordingLink(e.link)
        }
      })

      // keep moderator status live so the Start/Stop button appears/disappears without a rejoin
      context.root.api.addEventListener('participantRoleChanged', (e) => {
        if (e.id === localParticipantId.value) {
          myUser.value = { ...myUser.value, role: e.role }
        }
      })

      // hangup is intercepted (buttonsWithNotifyClick suppresses its default action):
      // stop an active recording first, then perform the actual leave ourselves —
      // otherwise the conference never ends and exitMeeting() never runs.
      context.root.api.addEventListener('toolbarButtonClicked', (e) => {
        if (e.key === 'hangup') {
          if (context.refs.navBar && context.refs.navBar.recording) {
            // recording active: stop it and let the download popup show, but stay
            // in the meeting instead of leaving — the user must be able to download
            // the recording. They can hang up again once the recording is stopped.
            context.root.api.executeCommand('stopRecording', 'file')
          } else {
            context.root.api.executeCommand('hangup')
          }
        }
      })

      context.root.api.addEventListener('outgoingMessage', () => {
        gaEvent({'ACTION': 'action', 'video_chat': 'sent'});
      })

      context.root.api.addEventListener('participantsPaneToggled', (msg) => {
        if (msg.open) {
          gaEvent({'ACTION': 'action', 'video_participants': ''});
        }
      })

      context.root.api.addEventListener('chatUpdated', (msg) => {
        if (msg.isOpen && lastChatState.value === false) {
          gaEvent({'ACTION': 'action', 'video_chat': ''});
        }
        lastChatState.value = msg.isOpen;
      })

      context.root.api.addEventListener('screenSharingStatusChanged', (e) => {
        if (e.on) {
          gaEvent({'ACTION': 'action', 'video_action': 'deskOn'})
        } else {
          gaEvent({'ACTION': 'action', 'video_action': 'deskOff'})
        }
      })

      context.root.api.addEventListener('audioMuteStatusChanged', (status) => {
        if (status.muted) {
          gaEvent({'ACTION': 'action', 'video_action': 'micOff'})
        } else {
          gaEvent({'ACTION': 'action', 'video_action': 'micOn'})
        }
      })

      context.root.api.addEventListener('videoMuteStatusChanged', (status) => {
        if (status.muted) {
          gaEvent({'ACTION': 'action', 'video_action': 'camOff'})
        } else {
          gaEvent({'ACTION': 'action', 'video_action': 'camOn'})
        }
      })

      context.root.api.addEventListener('errorOccurred', (e) => {
        console.warn('errorOccurred', e)
      })

      myUser.value = parseMyself(getJitsiToken())
    }

    function setMinimizeMode(value) {
      javaCall.value = true
      if (context.refs.containerMeeting) {
        javaMinimized.value = value
        if (javaMinimized.value) {
          expanded.value = false
        } else {
        }
      }
    }

    async function askMeetingInfo() {
      meetingInfo.value = {}
      let token = parseJwt(meta_token.value)
      if (corenexa_token.value != '') {
        const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer ' + corenexa_token.value }
        try {
          let meetingID = token.meetingID ? token.meetingID : token.room
          let response = await fetch(cnv_api.value + "/v1/meeting/" + meetingID, { headers })
          let json = await response.json() || {}
          if (json.error) {
            console.log('failed to get meeting details:', json.error)
          } else {
            meetingInfo.value = json
            meetingInfo.value.isModerator = token.moderator
            meetingInfo.value.guest = false
          }
        } catch (error) {
          console.log('failed to get meeting details:', error)
        }
      } else {
        let meetingID = token.meetingID ? token.meetingID : token.room
        meetingInfo.value.guest = true
        meetingInfo.value.ID = meetingID
        meetingInfo.value.title = meetingName.value
      }
    }

    function jitsiTokenExpired() {
      if (!meta_token.value) {
        return true;
      }

      let token = parseJwt(meta_token.value);
      if (Date.now() > token.exp * 1000) {
        return true;
      }

      return false;
    }

    async function putModeratorKey(key) {
      let me = myUser.value;
      let token = parseJwt(meta_token.value)
      const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer ' + corenexa_token.value }
      try {
        let params = {
          modPin: key,
          username: me.displayName,
          meetingID: token.meetingID ? token.meetingID : token.room
        }
        if (me.avatarUrl) {
          params.avatar = me.avatarUrl
        }

        let response = await fetch(cnv_api.value + "/pub/joinMeeting?" + new URLSearchParams(params).toString(), { headers })
        let json = await response.json() || {}
        if (response.status === 200) {
          var paramsJoin = new URLSearchParams({
                        meetingID: json.meetingID,
                        meetingName: json.meetingName,
                        domain: json.domain,
                        r: json.jwt,
                        c: corenexa_token.value,
                        api: cnv_api.value,
                        network: json.network,
                        directly: true
                      });
          window.location.href ='/#/JoinMeeting?' + paramsJoin.toString()
          window.location.reload()
        } else if (response.status === 401 && json.error === 'Wrong modPin') {
          context.root.$notify.info(context.root.$t("MEETING.POPUP_MODKEY_DONT_MATCH"), {visibility: 10000, closeButtonClass:'close'})
        }
      } catch (error) {
        console.log('Error while making user a moderator:', error)
      }
    }

    // called from Java code
    function javaLeave() {
      exitMeeting(false)
    }

    function exitMeeting(callJavaCode) {
      if (window.java && callJavaCode) {
        window.java.leave()
      }

      gaEvent({'ACTION': 'leave'})

      window.close()
      if (!window.closed) {
        context.root.$router.push({ name: 'ExitMeeting', params: { url: rejoinHref.value }})
        // window.location.assign('https://www.corenexa.com/')
      }
    }

    return {
      directly,
      expanded,
      inMeeting,
      domain,
      options,
      meetingName,
      meetingInfo,
      meta_token,
      corenexa_token,
      cnv_api,
      putModeratorKey,
      roomName,
      meet,
      exitMeeting,
      setMinimizeMode,
      javaCall,
      javaMinimized,
      askMeetingInfo,
      loadJsFile,
      joinJitsi,
      rejoinHref,
      myUser,
    }
  }
}
</script>

<style>
#popup{
  display: none;
}
</style>
<style scoped>
  .pushed{ width:calc(100% - 370px)!important; margin-left: 370px!important;}
  .spinner-border{
    width: 56px;
    height: 56px;
  }
  .connecting{
    background: #272727;
    max-width: 500px;
    padding: 40px;
    margin-top: 80px;
  }
  .small{
    color: #bbbbbb;
  }
  .mobileHeight{
    padding: 13px;
  }

  .top-bar {
    height: 45px;
  }

  .jitsi {
    height: 100vh;
  }
  .jitsi.meeting {
    height: calc(100vh - 48px);
  }
  
  .container-fluid {
    width: 100%; 
    height: 100%;
  }
  @media (min-width: 768px) {
    .container-fluid.meeting{
      margin-left: 0px;
      display: inherit;
    }
  }
  .videoArea {
    height: 100%;
    margin-left: -15px;
    margin-right: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/JoinMeeting.vue